import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const UPLOAD_BULLETIN_PATH = '/dashboard/systemadmin/upload-bulletin';
export const VIEW_BULLETIN_PATH = '/dashboard/systemadmin/view-bulletin';
export const UPDATE_BULLETIN_PATH = '/dashboard/systemadmin/update-bulletin';

export type BulletinAdminTab = 'upload' | 'update';

export const BulletinAdminTabs: React.FC<{ active: BulletinAdminTab }> = ({
    active,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const text = (key: string, defaultValue: string) =>
        t(`SystemAdmin.UploadBulletinPage.${key}`, { defaultValue });
    const isUpload = active === 'upload';

    return (
        <div className='upload-bulletin__tabs' role='tablist'>
            <button
                className={`upload-bulletin__tab ${
                    isUpload ? 'is-active' : ''
                }`}
                type='button'
                role='tab'
                aria-selected={isUpload}
                onClick={() => !isUpload && navigate(UPLOAD_BULLETIN_PATH)}
            >
                {text('UploadTab', 'Upload Bulletin')}
            </button>
            <button
                className={`upload-bulletin__tab ${
                    !isUpload ? 'is-active' : ''
                }`}
                type='button'
                role='tab'
                aria-selected={!isUpload}
                onClick={() => isUpload && navigate(VIEW_BULLETIN_PATH)}
            >
                {text('UpdateTab', 'Update Bulletin')}
            </button>
        </div>
    );
};
